import { DocumentSection } from '@/shared/api/transcriptor/transcriptorApi';

export const getDocumentSectionContent = (section: DocumentSection): string => {
  const userText = section.user_content?.text?.trim();

  if (userText) {
    return userText;
  }

  return (section.content ?? [])
    .map((contentElement) => contentElement.text)
    .filter(Boolean)
    .join('\n\n')
    .trim();
};
